<template>
  <ECharts :autoresize="true" :options="options"></ECharts>
</template>

<script>
import ECharts from "vue-echarts/components/ECharts.vue";
import "echarts/lib/chart/bar";
// import 'echarts/lib/component/tooltip';
import "echarts/lib/component/title";
import "echarts/lib/component/markLine";
import "echarts/lib/component/markPoint";

export default {
  components: {
    ECharts,
  },
  data() {
    return {
      options: {},
    };
  },
  props: {
    hdata: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
  },
  watch: {
    hdata() {
      if (this.hdata) {
        this.getInit();
      }
    },
  },
  created() {
    this.getInit();
  },
  methods: {
    // 获取X轴Y轴的数据
    getInit() {
      const data = [];
      const names = [];
      const products = [];
      for (let i = this.hdata.length - 1; i >= 0; i--) {
        let pro = this.hdata[i];
        names.push(pro.StationName);
        data.push(pro.Times);
        products.push(pro);
      }
      const opt = {
        title: {
          text: "",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          enterable: true,
          formatter: function (params) {
            var res;
            let pro = products[params[0].dataIndex];

            res =
              "<div><span>产品SN：</span>" +
              pro.SN +
              "</div>" +
              "<div><span>点位名称：</span>" +
              pro.StationName +
              "</div>" +
              "<div><span>更新次数：</span>" +
              pro.Times +
              "</div>";

            return res;
          },
        },
        legend: {},
        grid: {
          left: "3%",
          right: "5%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: "category",
          data: names,
          axisLabel: {
            interval: 0, //标签设置为全部显示
            formatter: function (params) {
              var newParamsName = ""; // 最终拼接成的字符串
              var paramsNameNumber = params.length; // 实际标签的字数
              var provideNumber = 10; // 每行能显示的字的个数
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
              /**
               * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
               */
              // 条件等同于rowNumber>1
              if (paramsNameNumber > provideNumber) {
                /** 循环每一行,p表示行 */
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = ""; // 表示每一次截取的字符串
                  var start = p * provideNumber; // 开始截取的位置
                  var end = start + provideNumber; // 结束截取的位置
                  // 此处特殊处理最后一行的索引值
                  if (p == rowNumber - 1) {
                    // 最后一次不换行
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    // 每一次拼接字符串并换行
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr; // 最终拼成的字符串
                }
              } else {
                // 将旧标签的值赋给新标签
                newParamsName = params;
              }
              //将最终的字符串返回
              return newParamsName;
            },
          },
        },
        series: [
          {
            name: "",
            type: "bar",
            data: data,
            barGap: "-50%",
            z: 3,
            itemStyle: {
              normal: {
                // 设置柱状颜色
                color(params) {
                  const colorList = [
                    "#fac858",
                    "#ee6666",
                    "#73c0de",
                    "#5470c6",
                    "#91cc75",
                  ];
                  return colorList[params.dataIndex];
                },
                label: { show: true, position: "right" },
              },
              // 鼠标悬停时：
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      this.options = opt;
    },
  },
};
</script>

<style scoped>
.echarts {
  width: 100%;
  height: 100%;
}
* {
  -webkit-user-select: text !important;
  user-select: text !important;
}
</style>
